import config from '../../config';

// Cache maintenance must not keep a successfully saved language control disabled.
export async function refreshUserCache() {
  let timer;
  try {
    const response = await Promise.race([
      fetch(`${config.get('bookApiURL')}/refresh_user/`, { method: 'POST', credentials: 'include' }),
      new Promise((resolve, reject) => { timer = setTimeout(() => reject(new Error('User cache refresh timed out')), 5000); }),
    ]);
    if (!response.ok) throw new Error(`User cache refresh failed (${response.status})`);
  } finally { clearTimeout(timer); }
}



// WEBPACK FOOTER //
// ./src/utils/refreshUserCache.js